import api from './api';

const formService = {
  list: async () => {
    const res = await api.get('/api/v1/forms');
    return res.data;
  },
  create: async (payload) => {
    const res = await api.post('/api/v1/forms', payload);
    return res.data;
  },
  getById: async (id) => {
    const res = await api.get(`/api/v1/forms/${id}`);
    return res.data;
  },
  update: async (id, payload) => {
    const res = await api.put(`/api/v1/forms/${id}`, payload);
    return res.data;
  },
  remove: async (id) => {
    await api.delete(`/api/v1/forms/${id}`);
    return { success: true };
  },
  getBySlug: async (slug) => {
    const res = await api.get(`/api/v1/forms/slug/${slug}`);
    return res.data;
  },
  submitBySlug: async (slug, payload) => {
    const res = await api.post(`/api/v1/forms/slug/${slug}/submit`, payload);
    return res.data;
  },
  listSubmissions: async (formId) => {
    const res = await api.get(`/api/v1/forms/${formId}/submissions`);
    return res.data;
  },
  exportSubmissionsCSV: async (formId) => {
    const res = await api.get(`/api/v1/forms/${formId}/submissions/export`, { responseType: 'blob' });
    return res.data;
  }
};

export default formService;
